
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCoordinate as ObiCoordinateElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-coordinate.js';
 
 
 

 
 export const ObiCoordinate = createComponent({
   react: React,
   tagName: 'obi-coordinate',
   elementClass: ObiCoordinateElement,
   events: {
     
   }
  });
 
 